import {Component, Inject, OnInit} from '@angular/core';
import {Validators, FormControl, FormBuilder} from '@angular/forms';
import {MatDialogRef, MAT_DIALOG_DATA, MatDialog} from '@angular/material/dialog';

import {CustomerService} from 'src/app/core/services/api/customer.service';
import {SpokesmenService} from 'src/app/core/services/api/spokesmen.service';
import {PeopleService} from 'src/app/core/services/api/people.service';
import {NewPersonComponent} from '../../new-person/new-person.component';
import { Swal2 } from 'src/app/core/utils/swal2.util';
import { ClienteEncargados } from 'src/app/core/contracts/models/cliente-encargados';
import { CargosService } from 'src/app/core/services/api/cargos.service';
import { Option } from 'src/app/core/contracts/models/option';
import { CargosFormComponent } from 'src/app/pages/maintenance/media/cargos/form/cargos-form.component';

@Component({
    selector: 'app-asignar-encargados-form',
    templateUrl: './asignar-encargados-form.component.html',
    styleUrls: ['./asignar-encargados-form.component.scss']
})
export class AsignarEncargadosFormComponent implements OnInit {
    public loading:boolean = false;

    myForm = this.formBuilder.group({
        persona_id: new FormControl<number | null>({ value: null, disabled: true }, [Validators.required]),
        filter: new FormControl<string | null>(null),
        cargo: new FormControl<number[] | null>(null),
        filterC: new FormControl<string | null>(null)
    });

    encargado: ClienteEncargados = {
        cliente_id: null,
        idEncargado: null,
    }

    cargos: any[] = [];

    personas: any[] = [];

    title = 'Agregar encargado';

    loader = true;

    constructor(
        private dialog: MatDialog,
        private formBuilder: FormBuilder,
        public dialogRef: MatDialogRef<AsignarEncargadosFormComponent>,
        @Inject(MAT_DIALOG_DATA) public data: { row: ClienteEncargados, id: number },
        private peopleService: PeopleService,
        private customerService: CustomerService,
        private spokesmenService: SpokesmenService,
        private swal: Swal2,
        private cargosService: CargosService,
    ) {
        if (data.row) {
            this.title = 'Editar encargado';
        }
    }

    ngOnInit(): void {

        this.cargosService.getAll().subscribe((response: any) => {
            const { cargos } = response;
            this.cargos = cargos;
            if (this.data.row) {
                const raw = (this.data.row as any).idsCargo || (this.data.row as any).ids_cargo || (this.data.row as any).cargos;
                let selectedIds: number[] = [];
                if (Array.isArray(raw)) {
                    if (raw.length && typeof raw[0] === 'object') {
                        selectedIds = raw.map((r: any) => Number(r.id ?? r.idCargo ?? r.cargo_id)).filter((v: number) => !isNaN(v) && v > 0);
                    } else {
                        selectedIds = raw.map((v: any) => Number(v)).filter((v: number) => !isNaN(v) && v > 0);
                    }
                } else if (typeof raw === 'string') {
                    selectedIds = raw.split(',').map((n: string) => Number(n.trim())).filter((n: number) => !isNaN(n) && n > 0);
                } else if (typeof raw === 'number') {
                    selectedIds = [raw].filter(v => v > 0);
                }
                if (!selectedIds.length && typeof (this.data.row as any).cargo === 'string') {
                    const labels = (this.data.row as any).cargo.split(',').map((s: string) => s.trim()).filter((s: string) => !!s);
                    selectedIds = this.cargos
                        .filter(c => labels.includes(c.descripcion))
                        .map(c => c.id);
                }
                if (selectedIds.length) {
                    this.myForm.controls.cargo.setValue(selectedIds);
                }
            }
        });

        if (this.data.row) {
            this.personas = [this.data.row.encargado]
            this.myForm.controls.persona_id.setValue(this.data.row.idEncargado);
            
        } else {
            this.peopleService.getAllSelect(true).subscribe((response: any) => {
                const {contactos} = response;
                this.personas = contactos.map(ct => {
                    ct.completeName = `${ct.nombres} ${ct.apellidos}`;
                    return ct;
                })
                this.myForm.controls.persona_id.enable({emitEvent: false});
            });
        }

    }

    onSubmit() {
        const rawCargo = this.myForm.controls.cargo.value as any;
        let idsCargo: number[] = [];
        if (Array.isArray(rawCargo)) {
            idsCargo = rawCargo.map((v: any) => Number(v)).filter((v: number) => !isNaN(v) && v > 0);
        } else if (typeof rawCargo === 'string') {
            idsCargo = rawCargo.split(',').map((n: string) => Number(n.trim())).filter((n: number) => !isNaN(n) && n > 0);
        } else if (typeof rawCargo === 'number') {
            idsCargo = [rawCargo].filter(v => v > 0);
        }
        this.encargado = {
            cliente_id: this.data.id,
            idEncargado: this.myForm.controls.persona_id.value,
            idsCargo: idsCargo
        }
        this.loading = true;

        if (this.data.row) {
            this.encargado.id = this.data.row.id;
            this.customerService.updateClienteEncargados(this.encargado).subscribe((response: any) => {
                this.loading=false;
                this.swal.showToast(response.message, 'success');
                this.dialogRef.close(response);
            }, error => {
                if (error.status === 400) {
                    this.error(error);
                }
                this.loading=false
            });
        } else {
            let person = this.personas.find(pr => pr.id == this.myForm.get('persona_id').value);
            this.customerService.createClienteEncargados(this.encargado).subscribe((response: any) => {

                this.swal.showToast(response.message, 'success');
                if (person.tiposPersona.includes('2')) {
                    const selectedIds: number[] = idsCargo;
                    let cliente = {
                        cliente_id: this.data.id,
                        idVocero: this.myForm.get('persona_id').value,
                        idsCargo: selectedIds
                    }
                    this.spokesmenService.createClienteVoceros(cliente).subscribe((response2: any) => {
                        this.dialogRef.close(response);
                        this.loading=false
                        this.swal.showToast(response2.message, 'success');
                    }, error => {
                        if (error.error.errors.idVocero) {
                            this.loading=false
                            this.dialogRef.close(response);
                        } else {
                            this.swal.showToast(error.error.message, 'error')
                            this.loading=false
                            this.dialogRef.close(response);
                        }


                    });
                } else {
                    this.dialogRef.close(response);
                }
                //this.dialogRef.close(response);
            }, error => {
                if (error.status === 400) {
                    this.error(error);
                }
                this.loading=false
            });
        }
    }

    getCargo(num) {
        let cargos = {
            1: 'Propietario',
            2: 'Representante legal',
            3: 'Coordinador de Marketing',
            4: 'Coordinador de comunicación'
        }

        return cargos[num]
    }

    error(error: any) {
        if (error.error.errors.persona_id) {
            this.swal.showToast(error.error.errors.persona_id[0], 'error');
        }
    }

    newPerson() {
        if (this.myForm.get('persona_id').value == -1) {
            this.dialog.open(NewPersonComponent, {
                data: {tipo: [], idCliente: null},
                width: '600px'
            }).afterClosed().subscribe(res => {
                if (res) {
                    // console.log(res);
                    this.personas.push(res);
                    res.completeName = res.nombres + ' ' + res.apellidos;
                    this.myForm.get('persona_id').setValue(res.id);
                } else {
                    this.myForm.get('persona_id').setValue(null);
                }
            });
        }
    }

    addCargo(row?) {
        const dialogRef = this.dialog.open(CargosFormComponent, {
            data: row,
            width: '500px'
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result && result.cargo) {
                const nuevoCargo = result.cargo;
                this.cargos.push(nuevoCargo);
                const seleccionActual = this.myForm.controls.cargo.value || [];
                if (!seleccionActual.includes(nuevoCargo.id)) {
                    this.myForm.controls.cargo.setValue([...seleccionActual, nuevoCargo.id]);
                }
                this.myForm.controls.filterC.setValue(null);
            }
        });
    }
}
